import { render, staticRenderFns } from "./period.vue?vue&type=template&id=5099690a&scoped=true"
import script from "./period.vue?vue&type=script&lang=js"
export * from "./period.vue?vue&type=script&lang=js"
import style0 from "./period.vue?vue&type=style&index=0&id=5099690a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099690a",
  null
  
)

export default component.exports